var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm",class:{ active: _vm.params.data.selected },attrs:{"type":"button"},on:{"click":_vm.select}},[_vm._v(" Select ")])}
var staticRenderFns = []

export { render, staticRenderFns }